export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            关于吃瓜入口
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            了解黑料吃瓜入口背后的故事与使命
          </p>
        </div>
        <div className="bg-background-50 rounded-xl border border-background-200 p-6 md:p-10">
          <div className="max-w-2xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              <strong className="text-foreground-900">吃瓜入口</strong>成立于2024年，是国内领先的黑料吃瓜内容聚合平台。
              我们聚合了<strong className="text-foreground-900">51黑料吃瓜入口</strong>、<strong className="text-foreground-900">黑料吃瓜在线</strong>、
              <strong className="text-foreground-900">51在线吃瓜今日吃瓜入口</strong>等多个热门渠道的最新内容，
              致力于为广大"吃瓜群众"提供最全面、最及时、最稳定的黑料浏览体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台支持<strong className="text-foreground-900">黑料视频在线看</strong>功能，
              覆盖娱乐圈、财经圈、网红圈、直播圈等多个领域。我们坚持每日更新，确保每一位访问
              <strong className="text-foreground-900">黑料吃瓜网入口</strong>的用户都能第一时间获取最新鲜的吃瓜内容。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们秉持"让吃瓜更简单"的理念，不断优化访问体验和内容质量。
              通过<strong className="text-foreground-900">黑料独家入口</strong>与多位圈内人士保持紧密合作，
              为平台用户带来独一无二的独家内容。无论你是资深瓜友还是刚刚入圈，
              吃瓜入口都是你探索精彩内容的最佳起点。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}